<template>
    <div id="app">

        <router-view></router-view>

        <footer class="tw-py-6 lg:tw-py-16" v-if="$route.path != '/b'">
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-flex-col tw-text-center">
                <img src="~@/assets/img/logo_text.svg" class="tw-pb-5">
                <p class="tw-pb-2"><span><b>Copyright © {{ new Date().getFullYear() }} Fidelidade. Todos os direitos reservados.</b></span></p>
                <p>Fidelidade - Companhia de Seguros, S.A. - NIPC e Matrícula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa – Portugal - Capital Social EUR 509.263.524</p>
                <p>Apoio ao Cliente: Dias úteis das 9h às 20h. Telefone: 217 948 701 - Chamada para a rede fixa nacional. Email: <a href="mailto:apoiocliente@fidelidade.pt">apoiocliente@fidelidade.pt</a>. <a href="https://www.fidelidade.pt" target="_blank">www.fidelidade.pt</a></p>
            </div>
        </footer>

        <footer v-else class="tw-py-6 lg:tw-py-16">
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-flex-col tw-text-center">
                <img src="~@/assets/img/logo_text.svg" class="tw-pb-5">
                <p><span>Fidelidade - Companhia de Seguros, S.A. - NIPC e Matrícula 500 918 880, na CRC Lisboa - Sede: Largo do Calhariz, 30 1249-001 Lisboa – Portugal - Capital Social EUR 509.263.524<br>
                Apoio ao Cliente: Dias úteis das 9h às 20h. Telefone: 217 948 701 - Chamada para a rede fixa nacional. Email: <a href="mailto:apoiocliente@fidelidade.pt">apoiocliente@fidelidade.pt</a>. <a href="https://www.fidelidade.pt" target="_blank">www.fidelidade.pt</a></span></p>
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <Clarity/>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
